import React  from "react";


export const ReadOnlyRowsMessage = ({ numTableColumns }) => (
    <tbody>
        <tr>
            <td className="u-br-none register-read-only-message" colSpan={3}>
                <svg className="icon-padlock" style={{ width: '20px', height: '20px', color: '#4A4A4A' }}>
                    <use xlinkHref="#icon-padlock"></use>
                </svg>
                &nbsp;&nbsp;
                <b>This is the content you have don't have permission to edit.</b>
            </td>
            <td colSpan={numTableColumns - 3} className="u-bg-color-dark-grey">&nbsp;</td>
        </tr>
    </tbody>
);

export const EditableRowsMessage = ({ numTableColumns }) => (
    <tbody>
        <tr>
            <td className="u-bg-color-light-green u-br-none" colSpan={3}>
                <svg className="icon-padlock-unlocked" style={{ width: '20px', height: '20px', color: 'green' }}>
                    <use xlinkHref="#icon-padlock-unlocked"></use>
                </svg>
                &nbsp;&nbsp;
                <b>This is the content you have permission to edit.</b>
            </td>
            <td colSpan={numTableColumns - 3} className="u-bg-color-light-green">&nbsp;</td>
        </tr>
    </tbody>
);
